// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useLayoutEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Button from '../_common/form/Button';
import Icon from '../_common/form/Icon';
import Title from '../_common/form/Title';
import Modal from '../_common/Modal';

import ShareButton from '../../assets/images/ShareButton.png'
import AddToHomeScreen from '../../assets/images/AddToHomeScreen.png'
import AddToHome from '../../assets/images/AddToHome.png'


const riseUp = keyframes`
    from{
        bottom: -20%;
    }
    to {
        bottom: 0%;
    }
`;

const Wrapper = styled.div`
    position: absolute;
    display: flex;
    width: 100vw;
    background: ${({ theme }) => theme.mobile.secondary};
    color: ${({ theme }) => theme.mobile.contrast};
    z-index: 1000;

    animation: ${riseUp};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;

    margin: 0.2em 1em;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
`
const ModalCol = styled(Col)`
    display: flex;
    flex-direction: column;
    margin: 0.3em 0;

    width: 100%;
    height: 100%;
`
const Img = styled.img`
    border-radius: 0.2rem;
    box-shadow: 1px 1px 3px 1px #00000040;
    width: 99%;
    margin: 0.1em;
`

const InstallerPrompt = ({ ...props }) => {

    const [installer, setInstaller] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [IOSdevice, setIOSDevice] = useState(false);

    useLayoutEffect(() => {
        setIOSDevice(navigator.userAgent.match(/iPhone|iPad|iPod/i));
        const ready = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', ready);
        return () => window.removeEventListener('beforeinstallprompt', ready);
    }, [])

    useEffect(() => {
        if (IOSdevice) setInstaller(true);

        if (!deferredPrompt) return;
        setInstaller(true)
    }, [deferredPrompt, IOSdevice])

    const showHelp = () => {
        Modal.Show({
            title: 'How to install on IOS',
            body: (
                <ModalCol>
                    <span>1. Click the share button.</span>
                    <Img src={ShareButton} />
                    <span>2. Click "Add to Home Screen".</span>
                    <Img src={AddToHomeScreen} />
                    <span>3. Click the "Add" button.</span>
                    <Img src={AddToHome} />
                </ModalCol>
            )
        })
    }

    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const installPWA = () => deferredPrompt.prompt();

    return !installer ? null :
        (
            <Wrapper>
                <Col>
                    <Row>
                        <Title>Install the App!</Title>
                    </Row>
                    <Row>Install the app to get the full experience.</Row>

                    <Row>
                        {
                            IOSdevice ?
                                <span>To Install this webApp on your iPhone: <br />• Tap <Icon icon='share' /> <br />• <Icon icon='squarePlus' /> Add to Home Screen</span> :
                                <>
                                    <Button onClick={() => setInstaller(false)}>Close</Button>
                                    <Button onClick={installPWA}>Install</Button>
                                </>
                        }
                    </Row>
                    {
                        IOSdevice ?
                            <Row>
                                <Button onClick={() => showHelp()}>Help</Button>
                                <Button onClick={() => setInstaller(false)}>Close</Button>
                            </Row> : null
                    }
                </Col>
            </Wrapper>
        );
}

export default InstallerPrompt;